/* eslint-disable no-use-before-define */

import React from 'react'

export const Header = ({context}) => {
    return <React.Fragment>
        <div className="row vertical-offset-sm" style={{borderBottom:"2px solid #e4e4e4"}}>
        <div className="col-md-10"><h3 className="medium-header">{context.issuer}</h3></div>
        <div className="col-md-2 text-right text-medium trade-history-header-cusip">{context.cusip}</div>
        </div>
    </React.Fragment>
}